import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from '../../../services/config/config.service';

@Component({
  selector: 'app-consulta-ticket',
  templateUrl: './consulta-ticket.component.html',
  styleUrls: ['./consulta-ticket.component.scss'],
  standalone: false,
})
export class ConsultaTicketComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  queryNumber: any = null;
  url: string = "";
  infoParametrizacion: any = {};
  @ViewChild('queryFrame') frame!: ElementRef;

  constructor(private config: ConfigService) {
  }

  ngOnInit(): void {
    this.infoParametrizacion = JSON.parse(localStorage.getItem('parametros') ?? "");
  }

  searchNumber = () => {
    this.url = this.config.urlHome + "venta/recibo/" + this.queryNumber + "/" + this.infoParametrizacion.idComprobante;
    this.frame.nativeElement.setAttribute('src', this.url);
  }

}
